import { getBlob, ref, uploadBytes } from "firebase/storage";
import { store } from "shared/api/firebase";

export const copyImage = async (
  sourceUrl: string | null | undefined,
  targetPath: string,
): Promise<string | null> => {
  if (!sourceUrl) return null;

  try {
    const filename = sourceUrl.split("/").pop() ?? "image";

    const sourceRef = ref(store, sourceUrl);

    const targetRef = ref(store, `${targetPath}/${filename}`);

    const blob = await getBlob(sourceRef);

    await uploadBytes(targetRef, blob);

    return `${targetPath}/${filename}`;
  } catch (error) {
    console.error("Error copying image:", error, sourceUrl);
    return null;
  }
};
